import cloneDeep from 'lodash/cloneDeep'

const restaurantOption = (restaurant) => ({
    key: restaurant['@id'],
    label: `${restaurant.name} (id: ${restaurant.id})`,
    id: restaurant.id,
    name: restaurant.name,
})

class BrandFormMapper {
    toEntity(values) {
        const entity = cloneDeep(values)

        if (entity.logo?.['@id']) {
            entity.logo = entity.logo['@id']
        }

        if (entity.cover?.['@id']) {
            entity.cover = entity.cover['@id']
        }

        delete entity.restaurantOptions

        return entity
    }

    fromEntity(entity) {
        const values = cloneDeep(entity)

        // Brand:read serializes restaurants as objects; the selector works with IRIs and
        // needs the objects as fallback options for members missing from the select list
        // (hidden + inactive profiles), otherwise it would silently drop them.
        if (Array.isArray(values.restaurants)) {
            values.restaurantOptions = values.restaurants
                .filter(
                    (restaurant) => restaurant && typeof restaurant === 'object'
                )
                .map(restaurantOption)
            values.restaurants = values.restaurants.map((restaurant) =>
                restaurant && typeof restaurant === 'object'
                    ? restaurant['@id']
                    : restaurant
            )
        }

        return values
    }
}

export default new BrandFormMapper()
